var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7359 2.26081C11.7634 0.288316 8.53098 0.251735 6.54652 2.23619L5.03926 3.74346L6.17063 4.87483L7.67789 3.36756C9.02559 2.01987 11.2449 2.03253 12.6045 3.39218C13.9642 4.75184 13.9769 6.97114 12.6292 8.31883L11.1219 9.8261L12.2533 10.9575L13.7605 9.4502C15.745 7.46574 15.7084 4.23331 13.7359 2.26081ZM3.3708 7.67466L4.87807 6.16739L3.7467 5.03602L2.23943 6.54329C0.254972 8.52774 0.291556 11.7602 2.26405 13.7327C4.23655 15.7052 7.46898 15.7418 9.45344 13.7573L10.9607 12.25L9.82934 11.1187L8.32207 12.6259C6.97438 13.9736 4.75508 13.961 3.39542 12.6013C2.03577 11.2416 2.02311 9.02235 3.3708 7.67466ZM10.1288 5.86482C9.79556 5.53161 9.25038 5.52668 8.91717 5.8599L5.866 8.91106C5.53278 9.24428 5.53771 9.78945 5.87092 10.1227C6.20414 10.4559 6.74931 10.4608 7.08253 10.1276L10.1337 7.07642C10.4669 6.74321 10.462 6.19804 10.1288 5.86482Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.a1be3f6a48e1d9f1b5161d5f96d075fb.svg";
export { ForwardRef as ReactComponent };